import React, { PropTypes } from 'react';

import PureRenderComponent from 'app/lib/PureRenderComponent';
import { Collapsible } from 'routes/app/components';

import Unit from './Unit';

export default class Units extends PureRenderComponent {

    static propTypes = {
        units: PropTypes.array.isRequired
    };

    render() {

        let {units, ...props} = this.props;

        if (!units.length) {
            return <div className="center-align">No units specified.</div>;
        } else {
            return (
                <Collapsible popout accordion>
                    {units.map((unit, index) => {
                        return <Unit unit={unit} index={index} key={index} {...props} />;
                    })}
                </Collapsible>
            );
        }


    }

}